<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button class="btn primary" type="primary" size="small" v-preventReClick
            @click="uploadEvt(1)">医保上传</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick
            @click="uploadEvt(2)">药监上传</el-button>
          <!-- <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button> -->
        </div>
        <div class="right">
          <div class="search">
            <!-- <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input> -->
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight"
        style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column width="180" prop="typeName" label="库存变更类型"></el-table-column>
        <el-table-column width="180" prop="supplierProductNo" label="供应商产品编码"></el-table-column>
        <el-table-column width="180" prop="productName" label="供应商产品名称"></el-table-column>
        <el-table-column width="180" prop="mainNo" label="主条码"></el-table-column>
        <el-table-column width="130" prop="traceNo" label="追溯码"></el-table-column>
        <el-table-column width="120" prop="batch" label="批次号">
          <template slot-scope="scope">
            {{ scope.row.batch?scope.row.batch:'-' }}
          </template>
        </el-table-column>

        <el-table-column width="170" prop="manufactureDate" label="生产日期">
          <template slot-scope="scope">
            {{ scope.row.manufactureDate?parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d} "):'-' }}
          </template>
        </el-table-column>
        <el-table-column width="170" prop="validityDate" label="有效期">
          <template slot-scope="scope">
            {{ scope.row.validityDate?parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d} "):'-' }}
          </template>
        </el-table-column>
        <el-table-column width="120" prop="price" label="采购价"></el-table-column>
        <el-table-column width="120" prop="number" label="数量"></el-table-column>
        <el-table-column width="120" prop="medicalInsuranceCategoryNo" label="医保代码"></el-table-column>
        <el-table-column width="170" prop="effectiveTime" label="库存变更时间">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.effectiveTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
          </template>
        </el-table-column>
        <el-table-column width="120" prop="remark" label="备注">
          <template slot-scope="scope">
            {{ scope.row.remark?scope.row.remark:'-' }}
          </template>
        </el-table-column>
        <el-table-column width="120" prop="stateName" label="医保上传状态"></el-table-column>
        <el-table-column width="120" show-overflow-tooltip prop="errMessage" label="医保失败原因">
          <template slot-scope="scope">
            {{ scope.row.errMessage?scope.row.errMessage:'-' }}
          </template>
        </el-table-column>
        <el-table-column width="120" prop="failureNumber" label="医保失败次数"></el-table-column>
        <el-table-column width="120" prop="drugStateName" label="药监上传状态"></el-table-column>
        <el-table-column width="120" show-overflow-tooltip prop="drugFailureNumber" label="药监失败次数"></el-table-column>
        <el-table-column width="120" prop="drugErrMessage" label="药监失败原因">
          <template slot-scope="scope">
            {{ scope.row.drugErrMessage?scope.row.drugErrMessage:'-' }}
          </template>
        </el-table-column>

      </el-table>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { GetStockChangeUploads, PushStockChangeToUdi, DrugPushReceiptToUdi } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import { ChargeCategoryOptions, ApproveStatusOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      GetDatasAction: GetStockChangeUploads,
      // PrintAction: GetAcceptInStockPrintData,
      // editPath: "surgical-use-edit",

      ChargeCategoryOptions: ChargeCategoryOptions,
      ApproveStatusOptions: ApproveStatusOptions,

    };
  },
  methods: {
    uploadEvt (num) {
      if (this.multipleSelection == 0) {
        this.$my_message("请勾选数据", "warning");
        return
      }
      let ids = this.multipleSelection.map(res => res.id)
      if (num == 1) {
        PushStockChangeToUdi({ ids }).then(res => {
          if (res.successful) {
            this.$my_message('操作成功', "success");
            this.getData()
          }
        })
      } else {
        DrugPushReceiptToUdi({ ids }).then(res => {
          if (res.successful) {
            this.$my_message('操作成功', "success");
            this.getData()
          }
        })
      }


    }
  },
  mounted () {


  },
};
</script>

<style lang="scss" scoped></style>
